module.exports = __webpack_public_path__ + "img/LOGO.e74ab1fe.png";